<script setup lang="ts">
</script>

<template>
  <div id="app">
    <router-view />
  </div>
</template>

